import './ConfirmedDataTooltip.scss'
interface Props {
  address?: string
  contact?: string
  tires?: string
  returns?: boolean
}
export default function ConfirmedDataTooltip({ address, contact, tires, returns }: Props) {
  return (
    <div className="tooltip">
      <ul className="confirmed-list">
        <li>
          <div className="flex">
            <div className="list-item-label">
              <i className="icon-manager"></i>
              <span className="list-item-text">{contact ?? ''}</span>
            </div>
          </div>
        </li>
        <li className="list-item">
          <div className="flex">
            <div className="list-item-label">
              <i className="icon-marker"></i>
              <span className="list-item-text">{address ?? ''}</span>
            </div>
          </div>
        </li>
        {!returns && (
          <li className="list-item">
            <div className="flex">
              <div className="list-item-label">
                <i className="icon-tire-storage"></i>
                <span className="list-item-text">{tires ?? ''}</span>
              </div>
            </div>
          </li>
        )}
      </ul>
    </div>
  )
}
